import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Slider,
  TextField
} from "@mui/material";
import { useBrushSettings } from "../../../Redux/hooks/useBrushSettings";

const BrushTool = ({style, current, updateStyle, updateSetting}) => {
  // Pull from hook
  // const { settings,  } = useBrushSettings();

  const { color, size, opacity } = current; // <- active brush settings
  console.log("BrushTool Rendered with style:", style, "and settings:", current);

  return (
    <Box p={2} width={250}>
      <Typography variant="subtitle1">Brush Style</Typography>
      <Select
        fullWidth
        value={style}
        onChange={(e) => updateStyle(e.target.value)}
      >
        <MenuItem value="brush">Brush</MenuItem>
        {/* <MenuItem value="calligraphyBrush">Calligraphy Brush</MenuItem> */}
        <MenuItem value="calligraphyPen">Calligraphy Pen</MenuItem>
        <MenuItem value="airbrush">Airbrush</MenuItem>
        <MenuItem value="oilBrush">Oil Brush</MenuItem>
        <MenuItem value="crayon">Crayon</MenuItem>
        <MenuItem value="marker">Marker</MenuItem>
        <MenuItem value="pencil">Natural Pencil</MenuItem>
        {/* <MenuItem value="watercolor">Watercolour Brush</MenuItem> */}
      </Select>

      <Typography mt={2}>Brush Settings</Typography>

      {/* Color Picker */}
      <TextField
        type="color"
        value={color}
        onChange={(e) => updateSetting("color", e.target.value)}
        fullWidth
        margin="normal"
      />

      {/* Size Slider */}
      <Typography>Size: {size}</Typography>
      <Slider
        value={size}
        onChange={(e, v) => updateSetting("size", v)}
        min={1}
        max={100}
      />

      {/* Opacity Slider */}
      <Typography>Opacity: {opacity}%</Typography>
      <Slider
        value={opacity}
        onChange={(e, v) => updateSetting("opacity", v)}
        min={0}
        max={100}
      />
    </Box>
  );
};

export default BrushTool;
